import { FieldArrayRenderProps } from 'react-final-form-arrays'
import { MatchPairsAnswerOption, MatchPairsSubtask } from '../../../../../../../types/commonTypes'
import { AnswerOptionsList } from '../components/AnswerOptionsList'
import { MatchPairsAnswerOption as MatchPairsAnswerOptionComponent } from './MatchPairsAnswerOption'
import { AutomatedFeedback } from '../components/AutomatedFeedback'
import { useTranslation } from 'react-i18next'

type MatchPairsSubtaskProps = {
  value: MatchPairsSubtask
  name: string
  noPoints?: boolean
  viewOnly: boolean
}

const mapFieldToAnswerOption = (
  name: string,
  index: number,
  fields: FieldArrayRenderProps<MatchPairsAnswerOption, any>['fields'],
  task: MatchPairsSubtask,
  viewOnly: boolean,
  noPoints?: boolean,
): JSX.Element => {
  return (
    <MatchPairsAnswerOptionComponent
      index={index}
      key={name}
      name={name}
      hasFixedPoints={task.data.allAnswersHaveSamePoints}
      fixedPoints={task.data.allAnswersPoints}
      onDelete={() => fields.remove(index)}
      noPoints={noPoints}
      viewOnly={viewOnly}
    />
  )
}

export const MatchPairsSubtaskFields: React.FC<MatchPairsSubtaskProps> = ({ value, name, noPoints, viewOnly }) => {
  const { t } = useTranslation()

  return (
    <>
      <AnswerOptionsList<MatchPairsSubtask>
        name={name}
        task={value}
        noPoints={noPoints}
        mapFieldToAnswerOption={mapFieldToAnswerOption}
        viewOnly={viewOnly}
      />
      <h5 style={{ marginTop: 16 }}>{t('game_editor.tasks.automated_feedback.title', 'Automated feedback')}</h5>
      <AutomatedFeedback name={name} allowRichText viewOnly={viewOnly} />
    </>
  )
}
